"use strict";

/**
 * Main object. Extended with functions like "core", "video", etc.
 * Check `onPageLoad()` function
 * @event flix:load
 * @example document.addEventListener('flix:load', () => {});
 */
var Flix = function () {
  var Flix = {};
  Flix.site = 'tnaflix';
  Flix.env = 'production';
  Flix.lang = 'en';
  /**
   * "/de", "/ru", etc or "" for English
   */
  Flix.urlLangPrefix = '';
  /**
   * E.g. "controllers.video.home","account.video.watchLater", etc
   */
  Flix.currentRouteId = '';
  /**
   * E.g. "vid", "categorySlug", etc.
   * Access it like this: Flix.routeArgs['page']
   * Hint how to set default value and avoid checking for undefined: (Flix.routeArgs['page'] ?? 1) != 1
   */
  Flix.routeArgs = {};
  Flix.ads = {
    /**
     * hash "utm_source": "iid"
     */
    mediabuys: {},
    iid: 0,
    utm_source: false,
    /**
     * Video categories and tags
     */
    tags: 'General',
    /**
     * If Ads completely disabled or enabled
     */
    enabled: true,
    /**
     * If it's special domain where we'll trigger pop on Chrome
     */
    wild: false,
    /**
     * Check if it's a SPECIFIC mediabuy from our base
     * @returns boolean
     */
    isSpecificBuy: function isSpecificBuy() {
      return Flix.ads.iid < 49990;
    },
    /**
     * If it's clear organic user. 
     * Not a specific mediabuy, not an unknown "utm_source"
     * @returns boolean
     */
    isOrganic: function isOrganic() {
      return !Flix.ads.isSpecificBuy() && !FlixUtils.hasCookie('utm_source');
    },
    /**
     * Check if adblock is enabled or not
     * @see https://gist.github.com/code-boxx/96b1fd2236d854965e3b6843af747014#file-3-load-dummy-html
     * @returns boolean
     */
    adblock: function adblock() {
      return window.flix_check_ad_is_ok === undefined;
    }
  };

  /**
   * @returns bool
   */
  Flix.isTna = function () {
    return Flix.site == 'tnaflix';
  };

  /**
   * @returns bool
   */
  Flix.isLocal = function () {
    return Flix.env == 'local';
  };

  /**
   * Initialize event handlers
   */
  function init() {
    // Load page info first time before page loaded
    parsePageConfig();

    // Listen on the page load
    if (typeof Turbolinks != 'undefined' && Turbolinks.supported) {
      document.addEventListener('turbolinks:load', onPageLoad);
    } else {
      document.addEventListener('DOMContentLoaded', onPageLoad);
    }
  }
  ;
  function getCookie(name) {
    var matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : null;
  }
  ;

  /**
   * Entrypoint. Here page config parsed and "flix:load" event triggered
   */
  function onPageLoad() {
    var _window$flix_current_;
    // turbolinks cannot update document.referrer, so this is a workaround. Use "window.referrer_fallback"
    window['referrer_fallback'] = (_window$flix_current_ = window['flix_current_url']) !== null && _window$flix_current_ !== void 0 ? _window$flix_current_ : document.referrer;
    window['flix_current_url'] = window.location.href;

    // Load page info
    parsePageConfig();

    // Set Ads data
    setIidAndUtmSource();

    // Trigger page load event that will be used to execute logic before "flix:load"
    document.dispatchEvent(new Event('flix:load:first'));

    // Trigger page load event
    document.dispatchEvent(new Event('flix:load'));
  }
  ;

  /**
   * Load page info
   */
  function parsePageConfig() {
    var pageInfo = JSON.parse(document.querySelector('#page-info').textContent);
    Flix.site = pageInfo.site;
    Flix.env = pageInfo.env;
    Flix.currentRouteId = pageInfo.currentRouteId;
    Flix.routeArgs = Object.keys(pageInfo.routeArgs).length ? pageInfo.routeArgs : {}; // check if it's empty or we'll have an array instead of object
    Flix.lang = pageInfo.lang;
    Flix.referrer = pageInfo.referrer || document.referrer;
    Flix.countryISO = pageInfo.country;
    Flix.requireAgeVerification = pageInfo.requireAgeVerification || getCookie('age_verified_mnt') == 'true';
    Flix.ageVerified = getCookie('age_verified_mnt') == 'true';
    Flix.ageverif = {};
    Flix.ageverif.siteId = pageInfo.ageVerify.siteId || 159; // default 159 is a test domain

    if (Flix.lang != 'en') {
      Flix.urlLangPrefix = '/' + Flix.lang;
    }
    Flix.ads.enabled = pageInfo.ads.enabled;
    Flix.ads.wild = pageInfo.ads.wild;
    Flix.ads.mediabuys = pageInfo.ads.mediabuys;
    Flix.ads.tags = document.querySelector('#video-data') ? encodeURI(JSON.parse(document.querySelector('#video-data').textContent).tags) : 'General';
  }
  ;

  /**
   * Set iid based on`utm_source` GET param or `utm_iid` cookie
   */
  function setIidAndUtmSource() {
    var _URL$searchParams$get;
    var _utm_src = (_URL$searchParams$get = new URL(window.location.href).searchParams.get('utm_source')) === null || _URL$searchParams$get === void 0 ? void 0 : _URL$searchParams$get.toLowerCase();
    if (_utm_src) {
      // came from mediabuy
      Flix.ads.utm_source = _utm_src;
      Flix.ads.iid = Flix.ads.mediabuys.hasOwnProperty(Flix.ads.utm_source) ? parseInt(Flix.ads.mediabuys[Flix.ads.utm_source]) : 49995;

      // Set cookie for 12 hours
      FlixUtils.setCookie('utm_iid', Flix.ads.iid, 1 / 2);
      FlixUtils.setCookie('utm_source', Flix.ads.utm_source, 1 / 2);
    } else if (FlixUtils.hasCookie('utm_iid')) {
      var _FlixUtils$getCookie;
      var _iid = parseInt(FlixUtils.getCookie('utm_iid'));
      Flix.ads.iid = isNaN(_iid) ? 49995 : _iid;
      // refresh cookie duration
      FlixUtils.setCookie('utm_iid', Flix.ads.iid, 1 / 2);
      var _utm_src = (_FlixUtils$getCookie = FlixUtils.getCookie('utm_source')) === null || _FlixUtils$getCookie === void 0 ? void 0 : _FlixUtils$getCookie.toLowerCase();
      if (_utm_src) {
        Flix.ads.utm_source = _utm_src;
        // refresh cookie duration
        FlixUtils.setCookie('utm_source', _utm_src, 1 / 2);
      }
    } else {
      Flix.ads.iid = 49990;
    }
  }
  ;

  // Initialize stuff
  init();
  return Flix;
}();